export default __webpack_public_path__ + "static/media/前沿议题沙龙.c71fe903.png";